import React from "react";

// reactstrap components
import {

  Container

} from "reactstrap";

// core components
import ColorNavbar from "components/Navbars/ColorNavbar.js";
import downloadPdfFromJson from "utils/downloadPdfFromJson.js";


function CertificadoAccesibilidad() {
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("about-us");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("about-us");
    };
  });
  return (
    <>
      <ColorNavbar />
      {/* <BlogPostHeader /> */}
      <div className="main" style={{ marginTop: "10em" }}>
        <div className="section">
          <Container>
            <center className="mt-5">
              <a
                href="#accesibilidad"
                role="button"
                style={{ textDecoration: "none !important", cursor: "pointer" }}
                onClick={(e) => {
                  e.preventDefault();
                  downloadPdfFromJson(
                    "/accesibilidad.json",
                    "accesibilidad.pdf"
                  );
                }}
              >
                <img
                  alt="Imagen con referencia Certificado Accesibilidad"
                  width="80px"
                  src={require("assets/img/sections/pdf.jpg")}
                ></img>
                <h6 className="my-3">Certificado de Accesibilidad</h6>
              </a>
            </center>
          </Container>
        </div>
      </div>
    </>
  );
}

export default CertificadoAccesibilidad;
